export default __webpack_public_path__ + "static/media/voltage_finance.b9e9fc00.svg";